export default {
  email: {
    required: 'El correo es requerido',
    valid: 'Introduce un correo válido'
  },
  street: 'La calle es requerida',
  exteriorNumber: 'El número exterior es requerido',
  interiorNumber: 'El número interior es requerido',
  neighborhood: 'La colonia es requerida',
  zipCode: 'El código postal es requerido',
  locality: 'La localidad es requerida',
  municipality: 'El municipio es requerido',
  state: 'El estado es requerido',
  country: 'El país es requerido',
  wansoftId: 'El ID de WanSoft es requerido',
  wansoftPdw: 'La contraseña de wansoft es requerido',
  certificate: 'El certificado es requerido',
  privateKey: 'La llave privada es requerida',
  privateKeyPassword: 'La contraseña de la llave privada es requerida',
  taxName: 'El nombre del impuesto es requerido',
  taxRegime: 'El régimen fiscal es requerido',
  taxId: 'El RFC es requerido',
  taxRegistrationNumber: 'El número de registro fiscal es requerido',
  file: 'El archivo es requerido',
  subrecipes: 'Las subrecetas son requeridas',
  password: 'La contraseña es requerida',
  confirmPassword: {
    required: 'La contraseña es requerida',
    match: 'Las contraseñas deben coincidir'
  },
  passwordConfirmation: {
    required: 'La contraseña es requerida',
    match: 'Las contraseñas deben coincidir'
  },
  firstName: 'El nombre es requerido',
  alphaNumericAcentuated: 'No se permiten carácteres especiales',
  lastName: 'El apellido es requerido',
  phone: 'El teléfono es requerido',
  required: 'Este campo es requerido',
  value: 'El valor es requerido',
  code: 'El código es requerido',
  restaurant: 'EL restaurante es requerido',
  product: 'El producto es requerido',
  price: 'El precio es requerido',
  unit: 'La unidad de medida es requerida',
  quantity: 'La cantidad es requerida',
  satCode: {
    required: 'El código del SAT es requerido',
    valid: 'Introduce un código válido'
  },
  service: 'El servicio es requerido',
  amount: 'El monto es requerido',
  choices: 'Los precios son requeridos',
  area: 'El área es requerida',
  xmlFile: 'El XML es requerido',
  numberValid: 'Introduce un número válido',
  total: 'El total es requerido',
  name: 'El nombre es requerido',
  provider: 'EL proveedor es requerido',
  ingredient: 'EL ingrediente es requerido',
  contentQuantity: 'La cantidad de contenido es requerida',
  contentUnit: 'La unidad de contenido es requerida',
  category: 'El departamento es requerido',
  yield: 'El rendimiento es requerido',
  max: 'El campo debe tener {count} dígitos máximo',
  description: 'La descripción es requerida',
  role: 'El rol es requerido',
  number: 'Se requiere un número',
  positive: 'Se requiere un número positivo'
}
